import Navbar from '../components/Navbar'
import Hero from '../components/sections/Hero'
import Services from '../components/sections/Services'
import WhyChooseMe from '../components/sections/WhyChooseMe'
import Process from '../components/sections/Process'
import Results from '../components/sections/Results'
import CtaSection from '../components/sections/CtaSection'
import Contact from '../components/sections/Contact'
import Footer from '../components/Footer'

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-cream grain-overlay">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyChooseMe />
        <Process />
        <Results />
        <CtaSection />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}

export default LandingPage
